import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import ReactDom from 'react-dom';
import App from 'components/App';
import store from 'store';
import messages from 'messages';

import pusher from 'sideEffects/pusher';
import cookie from 'sideEffects/cookie';

store.subscribe(() => {
  pusher(store);
  cookie(store);
});

ReactDom.render(
  <IntlProvider locale="en" messages={messages}>
    <Provider store={store}>
      <App />
    </Provider>
  </IntlProvider>,
  document.getElementById('root'),
);




// WEBPACK FOOTER //
// ./app/root.jsx